/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.preload)();
	
	//checkSP
	//preload
	
	(0, _module.checkSP)();
	
	//anchorLink
	// import {anchorLink} from "../include/module";
	// anchorLink();
	
	//resizeHeader
	
	(0, _module.resizeHeader)();
	
	//toggleMenu
	
	(0, _module.toggleMenu)();
	
	//  paraBg
	
	(0, _module.paraBg)();
	
	// ------------------------------------------------------------------------
	// swiper
	// ------------------------------------------------------------------------
	var chara_swiper = function chara_swiper() {
	  var charaThumbnail = new Swiper('.chara-Thumbnail', {
	    slidesPerView: 5,
	    freeMode: true,
	    watchSlidesVisibility: true,
	    watchSlidesProgress: true
	  });
	  var swiper = new Swiper('.chara-Content', {
	    // Optional parameters
	    hashNavigation: {
	      replaceState: true
	    },
	    loop: false,
	    allowTouchMove: false,
	    slidesPerView: 1,
	    speed: 500,
	    effect: "fade",
	    fadeEffect: {
	      crossFade: true
	    },
	    navigation: {
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev'
	    },
	    on: {
	      slideChange: function slideChange() {
	        swiperScroll();
	      }
	    },
	    thumbs: {
	      swiper: charaThumbnail
	    }
	  });
	};
	// $(window).on('load', function(){
	//   setTimeout(function () {
	//     chara_swiper();
	//   }, 100);
	// });
	
	
	$(window).on('load', function () {
	  setTimeout(function () {
	    chara_swiper();
	  }, 100);
	
	  //ページ外から
	  var urlHash = location.hash;
	  if (urlHash) {
	    setTimeout(function () {
	      swiperScroll();
	    }, 100);
	  }
	});
	
	function swiperScroll() {
	
	  var scrollSpeed;
	  var scrollTarget = $('#profile-List');
	  var scrollAdjust = 40;
	  var scrollPosition = scrollTarget.offset().top;
	
	  // if(!_isSP){
	  scrollSpeed = 300;
	  // }else{
	  // scrollSpeed = 0;
	  // }
	
	  $("html, body").animate({ scrollTop: scrollPosition - scrollAdjust }, scrollSpeed, "linear");
	  return false;
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	var _isSP = false;
	var _isTest = false;
	
	function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	}
	
	// preload
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	// checkSP
	var checkSP = function checkSP() {
	  $(window).on('resize load', function () {
	    windowW = $(window).width();
	    if (windowW <= 767) {
	      _isSP = true;
	    } else {
	      _isSP = false;
	    };
	  });
	};
	
	//toggleHeader
	var toggleHeader = function toggleHeader() {
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	    if (scrollPosition >= 70) {
	      $("#st-Header").addClass('st-Header-Shorten');
	    } else {
	      $("#st-Header").removeClass('st-Header-Shorten');
	    }
	  });
	};
	
	//anchorLink
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 80;
	      $('body,html').stop().animate({ scrollTop: position }, 500);
	    }, 200);
	  }
	
	  //ページ内リンク
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 80;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "easeInOutCubic");
	    return false;
	  });
	};
	
	//showMovie
	var showMovie = function showMovie() {
	  var trg = 0;
	  var ticker = 0;
	
	  $(window).on("load ", function () {});
	  $('.movie-wrap_inner, .sw-Modal .close').on('click', function () {
	    $(".sw-Modal").toggleClass("open");
	    if (trg == 0) {
	      videoControl("playVideo", '#youtube-modal');
	      trg = 1;
	    } else if (trg == 1) {
	      videoControl("stopVideo", '#youtube-modal');
	      trg = 0;
	    }
	  });
	  $(window).on("scroll", function () {
	    ticker++;
	    if (trg == 1 && ticker > 25) {
	      $(".sw-Modal").removeClass("open");
	      videoControl("stopVideo", '#youtube-modal');
	      trg = 0;
	    }
	    setTimeout(function () {
	      ticker = 0;
	    }, 500);
	  });
	};
	
	//toggleSidebar
	var toggleSidebar = function toggleSidebar() {
	  var controller = new ScrollMagic.Controller();
	  var scene01 = void 0;
	  var scene02 = void 0;
	  var flag = 0;
	  $(window).on('load resize', function () {
	    if (_isSP == false) {
	      var ltop = $('#column-news').offset().top;
	      var rtop = $('#column-nav').offset().top;
	
	      var ltopp = $('.idx-Main_Inner').offset().top + $('#column-news').outerHeight() - 30;
	      var rtopp = $('.idx-Main_Inner').offset().top + $('#column-nav').outerHeight() - 30;
	
	      var mainheight = $('.idx-Main_Inner').offset().top + $('.idx-Main_Inner').outerHeight();
	
	      var ftop = $('.st-Footer').offset().top;
	
	      var trgPos = ltop >= rtop ? ltop : rtop;
	      var trgContentHeight = ltopp >= rtopp ? ltopp : rtopp;
	
	      var rdur = ftop - rtopp;
	      var ldur = ftop - ltopp;
	
	      if (trgContentHeight >= mainheight) {
	        controller.destroy(true);
	        $(".idx-Main").css("padding-bottom", 0);
	        var ftopmargin = mainheight - $('#st-Footer').offset().top;
	        $(".idx-Main").css("height", trgContentHeight - 80);
	        flag = 0;
	      } else {
	        if (flag == 1) {
	          scene01.removePin(true);
	          scene02.removePin(true);
	          flag = 0;
	        }
	        $(".idx-Main").css("padding-bottom", "");
	        $(".idx-Main").css("height", "");
	        $("#pin-trigger").css("top", trgPos);
	        scene01 = new ScrollMagic.Scene({ triggerElement: "#pin-trigger", triggerHook: 0, duration: ldur }).setPin("#column-news").addTo(controller);
	        scene02 = new ScrollMagic.Scene({ triggerElement: "#pin-trigger", triggerHook: 0, duration: rdur }).setPin("#column-nav").addTo(controller);
	        flag = 1;
	      }
	    } else {
	      controller.destroy(true);
	      $(".idx-Main").css("padding-bottom", "");
	      $(".idx-Main").css("height", "");
	    }
	  });
	};
	
	//resizeHeader
	var resizeHeader = function resizeHeader() {
	  $(window).on("load scroll", function () {
	    var scrollHeight = $(this).scrollTop();
	    if (scrollHeight > 200) {
	      $(".st-Header").addClass("scrolled");
	    } else {
	      $(".st-Header").removeClass("scrolled");
	    }
	    if (scrollHeight > 400) {
	      $(".st-Pagetop").addClass("visible");
	    } else {
	      $(".st-Pagetop").removeClass("visible");
	    }
	  });
	};
	
	//toggleMenu
	var toggleMenu = function toggleMenu() {
	  $('.header-hamburger').on('click', function () {
	    $(this).toggleClass("open");
	    $(".header-nav").toggleClass("open");
	  });
	};
	
	//toggleLoading
	var toggleLoading = function toggleLoading() {
	  $(window).on("load", function () {
	    $(".st-Loading").addClass("loaded");
	    setTimeout(function () {
	      $(".idx-Col").addClass("loaded");
	    }, 300);
	  });
	};
	
	//resizeModal
	var resizeModal = function resizeModal() {
	  $(window).on('resize load', function () {
	    if (!matchMedia('(max-width: 798px)').matches) {
	      var dispWdt = window.innerWidth;
	      var dispHgt = window.innerHeight;
	      if (dispHgt > dispWdt) {
	        $(".sw-Modal_Inner .wrapper").addClass("resize");
	      } else {
	        $(".sw-Modal_Inner .wrapper").removeClass("resize");
	      }
	    }
	  });
	};
	
	//paraBg
	var paraBg = function paraBg() {
	  $(window).on('load', function () {
	    var contHeight = $(".st-Container").outerHeight();
	    var scrollHeightL = "";
	    var scrollHeightS = "";
	    if (matchMedia('(max-width: 798px)').matches) {
	      var scrollHeightL = contHeight / 1500 * 75;
	      var scrollHeightS = contHeight / 1500 * 50;
	    } else {
	      var scrollHeightL = contHeight / 1500 * 105;
	      var scrollHeightS = contHeight / 1500 * 65;
	    }
	    var controller = new ScrollMagic.Controller({ vertical: true });
	    var tween = new TimelineMax().add([TweenMax.to("body", 1, { backgroundPosition: "center -=" + scrollHeightL + "px, center -=" + scrollHeightS + "px" })]);
	    var scene = new ScrollMagic.Scene({ triggerElement: "body", duration: contHeight, offset: 0 }).setTween(tween).addTo(controller);
	    setTimeout(function () {
	      $("body").addClass("loaded");
	    }, 250);
	  });
	};
	
	//timelineReset
	var timelineReset = function timelineReset() {
	  var timer = 0;
	
	  var ua = navigator.userAgent;
	  if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document || ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) {
	    $(window).on('load orientationchange', function () {
	      if (timer > 0) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function () {
	        $(".tl-wrap_inner").empty();
	        $('.tl-wrap_inner').prepend('<a class="twitter-timeline" href="https://twitter.com/bang_dream_info?ref_src=twsrc%5Etfw" data-chrome="noheader nofooter transparent">Tweets by bang_dream_info</a>');
	        twttr.widgets.load($(".tl-wrap_inner"));
	      }, 1000);
	    });
	  } else {
	    $(window).on('load resize', function () {
	      if (timer > 0) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function () {
	        $(".tl-wrap_inner").empty();
	        $('.tl-wrap_inner').prepend('<a class="twitter-timeline" href="https://twitter.com/bang_dream_info?ref_src=twsrc%5Etfw" data-chrome="noheader nofooter transparent">Tweets by bang_dream_info</a>');
	        twttr.widgets.load($(".tl-wrap_inner"));
	      }, 1000);
	    });
	  }
	};
	
	exports.preload = preload;
	exports.checkSP = checkSP;
	exports.toggleHeader = toggleHeader;
	exports.showMovie = showMovie;
	exports.anchorLink = anchorLink;
	exports.resizeHeader = resizeHeader;
	exports.toggleSidebar = toggleSidebar;
	exports.toggleMenu = toggleMenu;
	exports.toggleLoading = toggleLoading;
	exports.resizeModal = resizeModal;
	exports.paraBg = paraBg;
	exports.timelineReset = timelineReset;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// character/app.bundle.js